export default __webpack_public_path__ + "static/media/codebutton.07b99225.png";